<mat-card-content>
  <div class="mt-2 pt-2" style="text-align: justify">
    @if ( helpAndSupportData && helpAndSupportData.length > 0) {
    <mat-accordion [multi]="true">
      @for (help of helpAndSupportData; track help; let i = $index) {
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center">
            <mat-icon class="heading-icon mr-2 skeleton-loader-item"></mat-icon>
            <span class="skeleton-loader-item skeleton-title"></span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="help-card-paragraph skeleton-loader-item"></p>
      </mat-expansion-panel>
      }
    </mat-accordion>
    } @else {
    <mat-card-content>
      <div class="mt-2 pt-2" style="text-align: justify">
        <mat-accordion [multi]="true">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="d-flex align-items-center">
                <mat-icon
                  class="heading-icon mr-2 skeleton-loader-item"
                ></mat-icon>
                <span class="skeleton-loader-item skeleton-title"></span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p class="help-card-paragraph skeleton-loader-item"></p>
            <p class="help-card-paragraph skeleton-loader-item"></p>
            <p class="help-card-paragraph skeleton-loader-item"></p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </mat-card-content>
    }
  </div>
</mat-card-content>
